export const OPEN_SNAPSHOTS_EMAIL_MODAL = 'OPEN_SNAPSHOTS_EMAIL_MODAL';
export const CLOSE_SNAPSHOTS_EMAIL_MODAL = 'CLOSE_SNAPSHOTS_EMAIL_MODAL';
